/* eslint-disable linebreak-style */
/* eslint-disable no-dupe-keys */
/* eslint-disable linebreak-style */
export const ThemeConfiguration = [
  {
    sno: 1,
    id: 1,
    themeName: 'Yellow & Red',
    // backgroundColor: "",
    // fontColor: "",
    // fontSize: "",
    noOfTextBlocks: 2,
    titleFontColor: '#ed297a',
    titleLineHeight: '2.2rem',
    titleFontSize: '30px',
    titleFontStyle: 'Ramabhadra',
    titleBackgroundColor: 'white',
    box1FontSize: '23px',
    box1FontColor: '#ed297a',
    box1FontStyle: 'Mallanna',
    box1LineHeight: '1.71rem',
    box1BackgroundColor: 'white',
    box2FontColor: 'White',
    box2FontSize: '23px',
    box2FontStyle: 'Mallanna',
    box2LineHeight: '1.9rem',
    box2BackgroundColor: '#000',
    box3FontColor: 'White',
    box3FontSize: '18.5px',
    box3FontStyle: 'Mallanna',
    box3LineHeight: '0.5rem',
    box3BackgroundColor: '#000',
    sampleImage:
      'https://cdn.yousay.tv/public/20221027/contents/ff548f12-e607-4fce-9520-4d9f115c6668',
  },
  {
    sno: 2,
    id: 2,
    themeName: 'Red & Yellow',
    // backgroundColor: "",
    // fontColor: "",
    // fontSize: "",
    noOfTextBlocks: 3,
    titleFontColor: '#ed297a',
    titleLineHeight: '2.2rem',
    titleFontStyle: 'Ramabhadra',
    titleFontSize: '28px',
    titleBackgroundColor: 'white',
    box1FontSize: '6px',
    box1FontColor: '#ed297a',
    box1FontSize: '23px',
    box1FontStyle: 'Mallanna',
    box1LineHeight: '1.56rem',
    box1BackgroundColor: 'white',
    box2FontColor: '#000',
    box2FontSize: '23px',
    box2FontStyle: 'Mallanna',
    box2LineHeight: '1.53rem',
    box2BackgroundColor: 'white',
    box3FontColor: 'white',
    box3FontSize: '23px',
    box3LineHeight: '1.54rem',
    box3BackgroundColor: '#000',
    sampleImage:
      'https://cdn.yousay.tv/public/20221227/contents/2385e6eb-b8ac-402d-8f91-3ce5330f1f4e',
  },
  {
    sno: 3,
    id: 2,
    themeName: 'Black & Yellow',
    // backgroundColor: "",
    // fontColor: "",
    // fontSize: "",
    noOfTextBlocks: 11,
    titleFontColor: 'white',
    titleLineHeight: '2.2rem',
    titleFontStyle: 'Ramabhadra',
    titleFontSize: '24px',
    titleBackgroundColor: 'white',
    box1FontSize: '6px',
    box1FontColor: 'yellow',
    box1FontSize: '25px',
    box1FontStyle: 'Mallanna',
    box1LineHeight: '2.1rem',
    box1BackgroundColor: 'black',
    box2FontColor: '#000',
    box2FontSize: '23px',
    box2FontStyle: 'Mallanna',
    box2LineHeight: '1.63rem',
    box2BackgroundColor: 'white',
    box3FontColor: 'white',
    box3FontSize: '23px',
    box3LineHeight: '1.63rem',
    box3BackgroundColor: '#000',
    sampleImage:
      'https://cdn.yousay.tv/public/20221227/contents/2385e6eb-b8ac-402d-8f91-3ce5330f1f4e',
  },

  // {sno:4,
  //   id: 5,
  //   themeName: "Purple & Pink",
  //   // backgroundColor: "",
  //   // fontColor: "",
  //   // fontSize: "",
  //   titleFontColor: "#fdef78",
  //   titleLineHeight: "4.5rem",
  //   titleBackgroundColor: "white",

  //   noOfTextBlocks: 1,
  //   box1FontSize: "20px",
  //   box1FontColor: "white",

  //   box1FontStyle: "Mallanna",
  //   box1LineHeight: "2.1rem",
  //   box1BackgroundColor: "black",
  //   box2FontColor: "#df678c",
  //   box2FontSize: "5px",
  //   box2LineHeight: "0.5rem",
  //   box2BackgroundColor: "#3d1560",
  //   box3FontColor: "#df678c",
  //   box3FontSize: "5px",
  //   box3LineHeight: "0.5rem",
  //   box3BackgroundColor: "#3d1560",
  //   sampleImage:
  //     "https://cdn.yousay.tv/public/20221111/contents/15ab39c8-da0d-43e6-9d7d-b23afb3d9372"
  // },
  {
    sno: 4,
    id: 4,
    themeName: 'discOneYellowBack',
    // backgroundColor: "",
    // fontColor: "",
    // fontSize: "",
    noOfTextBlocks: 4,
    titleFontColor: '#black',
    titleLineHeight: '2.3rem',
    titleFontStyle: 'Ramabhadra',
    titleFontSize: '26px',
    titleBackgroundColor: 'black',
    box1FontSize: '6px',
    box1FontColor: 'white',
    box1FontSize: '26px',
    box1FontStyle: 'mallanna',
    box1LineHeight: '1.61rem',
    box1BackgroundColor: 'black',
    box2FontColor: '#000',
    box2FontSize: '20px',
    box2FontStyle: 'Mallanna',
    box2LineHeight: '1.63rem',
    box2BackgroundColor: 'white',
    box3FontColor: 'white',
    box3FontSize: '20px',
    box3LineHeight: '1.63rem',
    box3BackgroundColor: '#000',
    sampleImage:
      'https://cdn.yousay.tv/public/20221227/contents/2385e6eb-b8ac-402d-8f91-3ce5330f1f4e',
  },
  {
    sno: 5,
    id: 2,
    themeName: 'toponedisc',
    // backgroundColor: "",
    // fontColor: "",
    // fontSize: "",
    noOfTextBlocks: 5, // not 5 only 1 box just for understanding
    titleFontColor: '#ed297a',
    titleLineHeight: '2.2rem',
    titleFontStyle: 'Ramabhadra',
    titleFontSize: '24px',
    titleBackgroundColor: 'white',
    box1FontSize: '6px',
    box1FontColor: 'black',
    box1FontSize: '23px',
    box1FontStyle: 'Mallanna',
    box1LineHeight: '2.1rem',
    box1BackgroundColor: 'white',
    box2FontColor: '#000',
    box2FontSize: '20px',
    box2FontStyle: 'Mallanna',
    box2LineHeight: '1.63rem',
    box2BackgroundColor: 'white',
    box3FontColor: 'white',
    box3FontSize: '20px',
    box3LineHeight: '1.63rem',
    box3BackgroundColor: '#000',
    sampleImage:
      'https://cdn.yousay.tv/public/20221227/contents/2385e6eb-b8ac-402d-8f91-3ce5330f1f4e',
  },
  {
    sno: 6,
    id: 1,
    themeName: 'topAndBottumDisc',
    // backgroundColor: "",
    // fontColor: "",
    // fontSize: "",
    noOfTextBlocks: 6, // but it is 2 boxs
    titleFontColor: '#ed297a',
    titleLineHeight: '2.2rem',
    titleFontSize: '30px',
    titleFontStyle: 'Ramabhadra',
    titleBackgroundColor: 'white',
    box1FontSize: '23px',
    box1FontColor: '#white',
    box1FontStyle: 'Mallanna',
    box1LineHeight: '2rem',
    box1BackgroundColor: 'white',
    box2FontColor: 'White',
    box2FontSize: '23px',
    box2FontStyle: 'Mallanna',
    box2LineHeight: '1.9rem',
    box2BackgroundColor: '#000',
    box3FontColor: 'White',
    box3FontSize: '21px',
    box3FontStyle: 'Mallanna',
    box3LineHeight: '2rem',
    box3BackgroundColor: '#000',
    sampleImage:
      'https://cdn.yousay.tv/public/20221027/contents/ff548f12-e607-4fce-9520-4d9f115c6668',
  },
]
